import { createContext } from 'react';

export interface AppContextProps {
  appType: string;
}

const AppContextDefault: AppContextProps = {
  appType: 'conversion-craft',
};

export const AppContext = createContext(AppContextDefault);
